import { Object3D } from 'three';
import { IEnemy } from '../enemy/IEnemy';

const DEFAULT_MAP_WORLD = 10000; // デフォルトワールド半径（±10000）

/**
 * ポーズ画面用の全体俯瞰マップ
 * 全体を1枚のCanvasで表示する
 */
export class PauseMap {
  private canvas: HTMLCanvasElement;
  private ctx: CanvasRenderingContext2D;
  private size: number;
  private mapWorld: number;

  constructor(mapWorld = DEFAULT_MAP_WORLD) {
    this.canvas = document.getElementById('pause-map-canvas') as HTMLCanvasElement;
    this.ctx    = this.canvas.getContext('2d')!;
    this.size   = this.canvas.width;
    this.mapWorld = mapWorld;
  }

  update(player: Object3D, enemies: IEnemy[]): void {
    const ctx = this.ctx;
    const s   = this.size;
    const cx  = s / 2;
    const cy  = s / 2;
    const r   = s / 2 - 10;

    ctx.clearRect(0, 0, s, s);

    // 背景
    ctx.fillStyle = 'rgba(0, 15, 0, 0.92)';
    ctx.fillRect(0, 0, s, s);

    // グリッド（5km単位）
    ctx.strokeStyle = 'rgba(0,200,80,0.15)';
    ctx.lineWidth = 1;
    for (let i = -10; i <= 10; i++) {
      const px = cx + (i / 10) * r;
      ctx.beginPath(); ctx.moveTo(px, cy - r); ctx.lineTo(px, cy + r); ctx.stroke();
      const py = cy + (i / 10) * r;
      ctx.beginPath(); ctx.moveTo(cx - r, py); ctx.lineTo(cx + r, py); ctx.stroke();
    }

    // 太い5km線
    ctx.strokeStyle = 'rgba(0,200,80,0.3)';
    ctx.lineWidth = 1.5;
    for (let i = -2; i <= 2; i++) {
      const px = cx + (i / 2) * r;
      ctx.beginPath(); ctx.moveTo(px, cy - r); ctx.lineTo(px, cy + r); ctx.stroke();
      const py = cy + (i / 2) * r;
      ctx.beginPath(); ctx.moveTo(cx - r, py); ctx.lineTo(cx + r, py); ctx.stroke();
    }

    // 外枠
    ctx.strokeStyle = 'rgba(0,255,100,0.5)';
    ctx.lineWidth = 2;
    ctx.strokeRect(cx - r, cy - r, r * 2, r * 2);

    // スケールラベル
    ctx.fillStyle = 'rgba(0,200,80,0.5)';
    ctx.font = '10px Courier New';
    ctx.textAlign = 'center';
    const gridKm = Math.round(this.mapWorld / 2000); // 半分の距離をkm単位で
    for (let i = -2; i <= 2; i++) {
      const km = i * gridKm;
      ctx.fillText(`${km}km`, cx + (i / 2) * r, cy + r + 14);
      ctx.fillText(`${km}km`, cx - r - 22, cy - (i / 2) * r + 4);
    }

    // 敵を描画
    for (const e of enemies) {
      if (!e.isAlive) continue;

      // ワールド座標 → マップ座標
      const mx = cx + (e.position.x / this.mapWorld) * r;
      const my = cy + (e.position.z / this.mapWorld) * r;

      if (e.isGroundUnit) {
        // 地上敵 = オレンジ丸（地上拠点シンボル）
        ctx.fillStyle = '#ff7744';
        ctx.strokeStyle = '#ffaa66';
        ctx.lineWidth = 1;
        ctx.beginPath();
        ctx.arc(mx, my, 5, 0, Math.PI * 2);
        ctx.fill();
        ctx.stroke();
      } else {
        // 空中敵 = 赤三角（航空機シンボル）
        ctx.fillStyle = '#ff4444';
        ctx.strokeStyle = '#ff8888';
        ctx.lineWidth = 1;
        ctx.beginPath();
        ctx.moveTo(mx, my - 6);
        ctx.lineTo(mx + 5, my + 4);
        ctx.lineTo(mx - 5, my + 4);
        ctx.closePath();
        ctx.fill();
        ctx.stroke();
      }
    }

    // 自機
    const px = cx + (player.position.x / this.mapWorld) * r;
    const py = cy + (player.position.z / this.mapWorld) * r;

    ctx.save();
    ctx.translate(px, py);
    // ワールドのヨー角をマップ上の回転に変換
    // Three.js: yaw正=左旋回、前方=-Z  マップ: 上=-Z, rotate正=時計回り
    ctx.rotate(-player.rotation.y);

    ctx.fillStyle = '#66aaff';
    ctx.strokeStyle = '#aaccff';
    ctx.lineWidth = 1.5;
    ctx.beginPath();
    ctx.moveTo(0, -9);   // 前方
    ctx.lineTo(5, 6);
    ctx.lineTo(0, 3);
    ctx.lineTo(-5, 6);
    ctx.closePath();
    ctx.fill();
    ctx.stroke();
    ctx.restore();

    // 凡例
    ctx.textAlign = 'left';
    ctx.fillStyle = '#66aaff';
    ctx.fillText('▲ PLAYER', cx + r - 90, cy + r - 30);
    ctx.fillStyle = '#ff4444';
    ctx.fillText('▲ ENEMY (AIR)', cx + r - 90, cy + r - 18);
    ctx.fillStyle = '#ff7744';
    ctx.fillText('● ENEMY (GND)', cx + r - 90, cy + r - 6);
  }
}
